import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './components'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ApiService from './services/api.service'
import { TokenService } from './services/storage.service'
import '../node_modules/nprogress/nprogress.css'
import "@/pitprojekt/filters";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment'
import 'moment/locale/pl';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import './assets/scss/style.scss'
import * as VueGoogleMaps from "vue2-google-maps";



Vue.use(Tooltip);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAk3YgbgsQTqYoHwsQnh_EssTpLQSh2iMQ",
    libraries: "places" // necessary for places input
  }
});
Vue.config.errorHandler = function (err, vm, info) {
  console.log('Error global');
  console.log(err);
}

Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.component('VueLoading', VueLoading);

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_PITPROJEKT_API_URL)

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
